import { TextField } from "@mui/material";
import styles from "./loginPage1.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAllProduct } from "../../api-context/commonApiContext";
import config from "../../service/config";

const Login = ({ className = "" }) => {
  const navigate = useNavigate();
  const {
    setRole,
    clientId,
    setClientId,
    setUserMail,
    setLoggedBy,
    setClientCompany,
    setMakerLimit,
    setApproverLimit,
    setUserId
  } = useAllProduct();
  const [email, setEmail] = useState("");
  const [otp, setOTP] = useState("");
  const [otpSend, setOtpSend] = useState(false);
  const [errorVerification, setErrorVerification] = useState("");

  const handleLogin = async () => {
    if (!email) {
      setErrorVerification("Email is required");
      return;
    }

    try {
      const res = await axios.post(
        `${config.node_api_endpoint}/api/send-otp`,
        {
          email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY, // ✅ Add your API key here
          },
        }
      );
      if (res.data.success) {
        setOtpSend(true);
        setErrorVerification("");
      } else {
        setErrorVerification("Failed to send OTP");
      }
    } catch (err) {
      setErrorVerification("Server error while sending OTP");
    }
  };

  const HandleOtp = async () => {
    if (!otp) {
      setErrorVerification("OTP is required");
      return;
    }

    try {
      const res = await axios.post(
        `${config.node_api_endpoint}/api/verify-otp`,
        {
          email: email.trim(),
          otp: otp.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY, // ✅ Add your API key here
          },
        }
      );

      if (res.data.success) {
        setErrorVerification("");

        const role = res.data.role;
        const loginBy = res.data.logged_by;
        const clientId = res.data.clientId;
        const userDetails = {
          role: role,
        };
        console.log("mail-->", res.data);

        localStorage.setItem("role", role);
        localStorage.setItem("clientId", clientId);
        localStorage.setItem("userMail", res.data.email);
        localStorage.setItem("loggedBy", res.data.logged_by);
        localStorage.setItem("client_company_name", res.data.company_name);
        localStorage.setItem("makerLimit", res.data.makerLimit);
        localStorage.setItem("approverLimit", res.data.approverLimit);
        localStorage.setItem("user_id", res.data.id);

        setRole(role); // Assuming you have this setter
        setLoggedBy(loginBy);
        setClientId(res.data.clientId);
        setUserId(res.data.id);
        setUserMail(res.data.email);
        setClientCompany(
          res?.data?.company_name?.length > 0 ? res.data.company_name : ""
        );
        setMakerLimit(Number(res.data.makerLimit));
        setApproverLimit(Number(res.data.approverLimit));
        console.log("check Role--->", role);

        switch (role.toString()) {
          case "admin":
            navigate("/escrow-management");
            break;
          case "Client":
            navigate("/transaction");
            break;
          case "user":
            navigate("/transaction");
            break;
          default:
            navigate("/transaction");
            break;
        }
      } else {
        setErrorVerification("Invalid OTP");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setErrorVerification("Server error while verifying OTP");
    }
  };

  const resendOtp = () => {
    setOTP("");
    handleLogin();
  };

  return (
    <div className={[styles.pageContainer, className].join(" ")}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <img
            className={styles.escrowstackLogos27Icon}
            alt="Logo"
            src="/Layer1.svg"
          />
        </div>
        <div className={styles.welcomeToYourEscrowStackParent}>
          <div className={styles.welcomeToYour}>
            Welcome to your Escrow Stack
          </div>
          <div className={styles.pleaseSignInTo}>
            Please sign-in to continue
          </div>
        </div>

        {!otpSend ? (
          <div className={styles.inputoutlinedParent}>
            <TextField
              fullWidth
              autoFocus
              label="Enter your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              sx={{ mb: 5, borderRadius: "12px" }}
            />
            {errorVerification && (
              <div className={styles.error}>{errorVerification}</div>
            )}
            <div className={styles.loadsButtons} onClick={handleLogin}>
              <img
                src="/boxarrowindown3.svg"
                alt=""
                className={styles.boxArrowInDownIcon}
              />
              <b className={styles.loads}>Get OTP</b>
            </div>
          </div>
        ) : (
          <div className={styles.inputoutlinedParent}>
            <TextField
              fullWidth
              autoFocus
              inputProps={{ maxLength: 6 }}
              label="Enter OTP"
              value={otp}
              onChange={(e) => setOTP(e.target.value.trim())}
              sx={{ borderRadius: "12px" }}
            />
            {errorVerification && (
              <div className={styles.error}>{errorVerification}</div>
            )}
            <div className={styles.loadsButtons} onClick={HandleOtp}>
              <img
                src="/boxarrowindown3.svg"
                alt=""
                className={styles.boxArrowInDownIcon}
              />
              <b className={styles.loads}>VERIFY OTP</b>
            </div>
            <div className={styles.loadsButtons} onClick={resendOtp}>
              <img
                src="/boxarrowindown3.svg"
                alt=""
                className={styles.boxArrowInDownIcon}
              />
              <b className={styles.loads}>RESEND OTP</b>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
